import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-sad',
  templateUrl: './sad.component.html',
  styleUrls: ['./sad.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SadIconComponent {}
